import { normalizeChatCompletionData } from './normalizeChatCompletionData.js'
import { readHermesStream } from './hermesSseReader.js'
import { postHermesStreamResponse } from './hermesStreamHttp.js'
import { waitForChatRun } from './chatRunPolling.js'

export function isMissingHermesStream(result) {
  return result?.ok === false && ['HTTP_404', 'HTTP_405'].includes(result.code)
}

export async function postHermesStreamCompletion({ path, body, signal, onEvent }) {
  try {
    const response = await postHermesStreamResponse({ path, body, signal })
    if (!response.ok) return httpErrorResult(response)

    const data = await readHermesStream(response, { onEvent })
    if (data?.__chatRunPoll) {
      return normalizeStreamFallback(await waitForChatRun(data.__chatRunPoll, signal, { onEvent }))
    }
    if (data?.__chatRunError) {
      return { ok: false, code: 'RUN_FAILED', message: data.__chatRunError }
    }
    return normalizeChatCompletionData(data)
  } catch (err) {
    if (err?.name === 'AbortError' || err?.code === 'ERR_CANCELED') {
      return { ok: false, code: 'ABORTED', message: 'Request was cancelled.' }
    }
    return {
      ok: false,
      code: 'NETWORK',
      message: err instanceof Error ? err.message : 'Could not reach the Hermes stream.',
    }
  }
}

function normalizeStreamFallback(data) {
  if (data?.__chatRunError) {
    return { ok: false, code: 'RUN_FAILED', message: data.__chatRunError }
  }
  return normalizeChatCompletionData(data)
}

async function httpErrorResult(response) {
  const detail = await response.text().catch(() => '')
  return {
    ok: false,
    code: `HTTP_${response.status}`,
    message: detail || `Hermes stream failed with HTTP ${response.status}`,
  }
}
